import React, { useRef } from 'react'
import './FormWrapper.scss'
import { FooterContent, HeaderContent } from 'common.types'

interface FormWrapperProps {
  children: React.ReactNode
  title: string
  id: string
  formRef?: any
  headerContent?: HeaderContent
}

export const FormWrapper: React.FC<FormWrapperProps> = ({
  children,
  id,
  title,
  formRef,
  headerContent,
}) => {
  return (
    <form className="form-wrapper" id={id} ref={formRef}>
      <header className="form-wrapper__header">
        <h3 className="form-wrapper__title">{title}</h3>
        {headerContent ? React.createElement(headerContent) : null}
      </header>
      <div className="form-wrapper__inner">
        <main className="form-wrapper__body">{children}</main>
      </div>
    </form>
  )
}
